module.exports = __webpack_public_path__ + "img/icon-hamburger.edcd93f5.svg";